import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../../services/data-format.service";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {Apollo} from "apollo-angular";
import {
  update_green_building,
  update_green_features,
  update_other_green, update_other_reports,
  update_special_needs
} from "./graphql/alterAssetManagement";
import {FormControl} from "@angular/forms";

export interface assetManagementTable {
  field: string;
  value: string;
}

@Component({
    selector: 'deal-asset-management',
    templateUrl: './asset-management.component.html',
    styleUrls: ['./asset-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssetManagementComponent implements OnInit{
  @Input() assetManagement: any;
  @Input() permissions: any;
  @Input() projectid: string;

  dataColumns: string[] = ['field', 'value'];
  dataSource: MatTableDataSource<assetManagementTable>;

  isEditMode: boolean = false;
  greenPureBool: boolean | null = null;
  green: string = 'n/a';
  newGreen: boolean | string = 'n/a';

  specialNeeds: string = '';
  specialEditMode: boolean = false;
  special: FormControl;
  specialChanged: boolean = false;

  greenBuilding: string = '';
  greenBuildingEditMode: boolean = false;
  greenB: FormControl;
  greenBuildingChanged: boolean = false;

  otherGreen: string = '';
  otherGreenEditMode: boolean = false;
  otherG: FormControl;
  otherGreenChanged: boolean = false;

  otherReports: string = '';
  otherReportsEditMode: boolean = false;
  otherR: FormControl;
  otherReportsChanged: boolean = false;

  constructor(private dataFormat: DataFormatService,
              private apollo: Apollo,
              private _snackBar: MatSnackBar) {}

  ngOnInit() {
    if(this.assetManagement){
      this.greenPureBool = this.assetManagement.green_features_flag;
      if(this.assetManagement.green_features_flag !== null){
        this.green = this.dataFormat.yesNoFormat(this.assetManagement.green_features_flag);
        this.newGreen = this.assetManagement.green_features_flag;
      }

      this.specialNeeds = this.assetManagement.special_needs_set_aside_description;
      this.special = new FormControl(this.assetManagement.special_needs_set_aside_description);

      this.greenBuilding = this.assetManagement.green_building_certifications;
      this.greenB = new FormControl(this.assetManagement.green_building_certifications);

      this.otherGreen = this.assetManagement.other_green_features;
      this.otherG = new FormControl(this.assetManagement.other_green_features);

      this.otherReports = this.assetManagement.other_reports;
      this.otherR = new FormControl(this.assetManagement.other_reports);
    } else {
      this.specialNeeds = '';
      this.special = new FormControl('');

      this.greenBuilding = '';
      this.greenB = new FormControl('');

      this.otherGreen = '';
      this.otherG = new FormControl('');

      this.otherReports = '';
      this.otherR = new FormControl('');
    }
    this.formatTableData()
  }

  formatTableData(){
    let assetMgntTable: Array<assetManagementTable>;
    assetMgntTable = [
      {field: 'Green Features?', value: this.dataFormat.yesNoFormat(this.greenPureBool)},
    ];

    this.dataSource = new MatTableDataSource(assetMgntTable);
  }

  toggleEditMode(){
    if(this.isEditMode && this.green !== this.newGreen){
      let greenbool: boolean | null;
      if(this.newGreen === 'n/a'){
        greenbool = null;
      } else{
        greenbool = Boolean(this.newGreen);
      }

      let mutate = {};
      if(this.assetManagement){
        mutate = {
          id: this.assetManagement.id,
          project_id: this.projectid,
          green_features_flag: greenbool
        }
      } else {
        mutate = {
          project_id: this.projectid,
          green_features_flag: greenbool
        }
      }
      this.apollo
        .mutate({
          mutation: update_green_features,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            let newdata: any = data.updateGreenFeatures;

            this.greenPureBool = newdata.green_features_flag;

            if(this.greenPureBool !== null){
              this.green = newdata.green_features_flag;
              this.newGreen = newdata.green_features_flag;
            } else {
              this.green = 'n/a';
              this.newGreen = 'n/a';
            }

            this.formatTableData();
            this.openSnackBar('Asset Management Details has been updated successfully.');
          }
        );
    }
    this.isEditMode = !this.isEditMode;
  }

  toggleSpecialEditMode(){
    if(this.specialEditMode && this.specialChanged){
      let mutate = {};
      if(this.assetManagement){
        mutate = {
          id: this.assetManagement.id,
          project_id: this.projectid,
          special_needs_set_aside_description: this.special.value
        }
      } else {
        mutate = {
          project_id: this.projectid,
          special_needs_set_aside_description: this.special.value
        }
      }
      this.apollo
        .mutate({
          mutation: update_special_needs,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.assetManagement = data.updateSpecialNeeds;
            this.specialNeeds = this.assetManagement.special_needs_set_aside_description;
            this.special.setValue(this.specialNeeds);
            this.specialChanged = false;
            this.openSnackBar('Special Needs Set Aside Description has been updated successfully.');
          }
        );
    }
    this.specialEditMode = !this.specialEditMode;
  }

  toggleGreenBuildingEditMode(){
    if(this.greenBuildingEditMode && this.greenBuildingChanged){
      let mutate = {};
      if(this.assetManagement){
        mutate = {
          id: this.assetManagement.id,
          project_id: this.projectid,
          green_building_certifications: this.greenB.value
        }
      } else {
        mutate = {
          project_id: this.projectid,
          green_building_certifications: this.greenB.value
        }
      }
      this.apollo
        .mutate({
          mutation: update_green_building,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.assetManagement = data.updateGreenBuilding;
            this.greenBuilding = this.assetManagement.green_building_certifications
            this.greenB.setValue(this.greenBuilding);
            this.greenBuildingChanged = false;
            this.openSnackBar('Green Building Certifications has been updated successfully.');
          }
        );
    }
    this.greenBuildingEditMode = !this.greenBuildingEditMode;
  }

  toggleOtherGreenEditMode(){
    if(this.otherGreenEditMode && this.otherGreenChanged){
      let mutate = {};
      if(this.assetManagement){
        mutate = {
          id: this.assetManagement.id,
          project_id: this.projectid,
          other_green_features: this.otherG.value
        }
      } else {
        mutate = {
          project_id: this.projectid,
          other_green_features: this.otherG.value
        }
      }
      this.apollo
        .mutate({
          mutation: update_other_green,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.assetManagement = data.updateOtherGreen;
            this.otherGreen = this.assetManagement.other_green_features
            this.otherG.setValue(this.otherGreen);
            this.otherGreenChanged = false;
            this.openSnackBar('Other Green Features has been updated successfully.');
          }
        );
    }
    this.otherGreenEditMode = !this.otherGreenEditMode;
  }

  toggleOtherReportsEditMode(){
    if(this.otherReportsEditMode && this.otherReportsChanged){
      let mutate = {};
      if(this.assetManagement){
        mutate = {
          id: this.assetManagement.id,
          project_id: this.projectid,
          other_reports: this.otherR.value
        }
      } else {
        mutate = {
          project_id: this.projectid,
          other_reports: this.otherR.value
        }
      }
      this.apollo
        .mutate({
          mutation: update_other_reports,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.assetManagement = data.updateOtherReports;
            this.otherReports = this.assetManagement.other_reports
            this.otherR.setValue(this.otherReports);
            this.otherReportsChanged = false;
            this.openSnackBar('Other Reports has been updated successfully.');
          }
        );
    }
    this.otherReportsEditMode = !this.otherReportsEditMode;
  }

  openSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }
}
